export default {
  websiteSytle: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000511","网站风格") /* "网站风格" */,
  green: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000512","绿色") /* "绿色" */,
  orange1: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000513","橙色1") /* "橙色1" */,
  orange2: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000514","橙色2") /* "橙色2" */,
  red: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000515","红色") /* "红色" */,
  blue1: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000516","蓝色1") /* "蓝色1" */,
  blue2: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000517","蓝色2") /* "蓝色2" */
};
